export default __webpack_public_path__ + "static/media/pic1.727a6b23.jpg";